module.exports = __webpack_public_path__ + "media/images/hubbleiq_favicon-8966b377b42f258b53c929da58811152.png";